import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import React from "react";
import Button from "../UI/Button";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  title: {
    marginBottom: "10px",
  },
});

const UsuarioTableSelectView = ({ usuarios, onUsuarioSelected }) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.title} variant="body1">
        Selecione uma turma
      </Typography>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {usuarios.map((usuario) => (
            <TableRow key={usuario.id}>
              <TableCell>{usuario.nome}</TableCell>
              <TableCell>{usuario.email}</TableCell>
              <TableCell>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  onClick={() => onUsuarioSelected(usuario)}
                  className={classes.submit}
                >
                  Selecionar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default UsuarioTableSelectView;
